import { createSlice } from "@reduxjs/toolkit";

const previewSlice = createSlice({
    name: 'jobPreview',
    initialState: {
        jobPreview: null
    },
    reducers: { 
        setJobPreview: (state, action) => {
            state.jobPreview = action.payload
        }
    }
})

export const {
    setJobPreview
} = previewSlice.actions

export default previewSlice.reducer